module.exports = __webpack_public_path__ + "static/favicon-3a2f136996ea956dfbfaa2f6dd91eeaa.png";